// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_3JYhF","backButton":"_1FyoX","textCount":"_2lI5m","users":"Y9rI7","user":"C-_zp","userAvatar":"kJW3N","userLetter":"_3yW-J"};